import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ConfigService } from './core/services/config.service';
import { SharedModule } from './shared/shared.module';
import { AppConfigService } from './core/services/app-config.service';
import { BreadcrumbModule } from './shared/breadcrumb/breadcrumb.module';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { DataTablesModule } from "angular-datatables";

export function initializeApp(config: ConfigService) {
    return () => config.load();
}

export function initializeAppConfig(appConfigService: AppConfigService) {
    return () => appConfigService.loadConfig();
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(),
        BrowserAnimationsModule,
        SharedModule,
        BreadcrumbModule,
        NgxUiLoaderModule,
        NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
        DataTablesModule
    ],
    providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [ConfigService],
        multi: true
    },
    {
        provide: APP_INITIALIZER,
        useFactory: initializeAppConfig,
        deps: [AppConfigService],
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
